<template>
  <div>
    {{ rowValue }}
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    cellData: {
      type: Object,
      default: () => {},
    },
    dependentRoute:String,
    relateName:String,
    slug:String
  },

  data: function () {
    return {
      rowValue: "",
    };
  },
  methods: {
    getDependentValue(itemId) {
      if (itemId == null || itemId === "undefined") {
        return;
      }
      let url =
        "/" + this.slug + "/" + this.dependentRoute + "/getById/" + itemId;
      return axios
        .get(url)
        .then((response) => {
          console.log("DEPENDENT FIELD RESP ".response );
          // Return the resolved data
         this.rowValue  = response.data.data.name;
          // return response.data.data.name;
        })
        .catch((error) => {
          console.error("Error fetching dependent value:", error);
          // Optionally, you can throw the error to propagate it to the caller
          throw error;
        });
    },
  },
  mounted() {
    //this.rowValue = "ss";
    console.log("LIST DEPND cellData ", this.cellData);
    if (this.cellData.value) {
       //this.cellData.value.name;
       this.getDependentValue(this.cellData.value)
    }
  },
};
</script>

<style>
</style>